// @flow
import { httpPost, httpGet } from '../helpers/helpers.api';

export function patchNode(patch: Object, deviceType: string, id: string): Promise<Response> {
    return httpPost(`nodes/${deviceType}/${id}`, patch);
}

export function getNodeCreationStatus(id: string): Promise<Response> {
    return httpGet(`node-creation/poll/${id}`);
}



// WEBPACK FOOTER //
// ./src/core/api/nodes/nodes.api.js